import { render, staticRenderFns } from "./addPlatform.vue?vue&type=template&id=3f4d281c&scoped=true&"
import script from "./addPlatform.vue?vue&type=script&lang=js&"
export * from "./addPlatform.vue?vue&type=script&lang=js&"
import style0 from "./addPlatform.vue?vue&type=style&index=0&id=3f4d281c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d281c",
  null
  
)

export default component.exports